<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-13 14:17:49
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-30 15:25:55
 * @FilePath: \hzs-nutra-wecom-shop\src\views\transformCustomer\transformCustomer.vue
 * @Description: 客户转移
-->

<template>
  <div class="page-container">
    <div class="mainContent">
      <p class="tips">
        <span> 批量转移员工跟进的客户，同时邀请客户添加新负责人的企微 </span>
      </p>
      <van-tabs
        v-model:active="manageMsgData.currentShopId"
        @click-tab="onClickTab"
      >
        <van-tab
          v-for="(item, index) in state.myShopList"
          :key="index"
          :title="item.text"
          :name="item.value"
        >
        </van-tab>
      </van-tabs>

      <div class="inner">
        <div class="manageMsg">
          <van-cell title="当前负责人" :value="currentManager?.shop_clerk_name">
            <template #value>
              <!-- <div
                class="df align-center justify-se"
                @click="showPositionPicker = true"
              >
                <span class="">{{ currentManager?.shop_clerk_name }}</span>
                <span
                  v-if="currentManager?.shop_clerk_status == 2"
                  class="aaaa"
                >
                  已离职
                </span>

                （<span class="shopName">
                  {{ manageMsgData.currentShopName }}
                  <i class="icon dib editIcon"></i> </span
                >）
              </div> -->

              <span class="">{{ currentManager?.shop_clerk_name }}</span>
              <span v-if="currentManager?.shop_clerk_status == 2" class="aaaa">
                已离职
              </span>
              <span class="shopName">
                ({{ manageMsgData.currentShopName }})
              </span>
            </template>
          </van-cell>
          <van-cell
            title="新负责人"
            is-link
            :value="nextManager?.shop_clerk_name"
            @click="handleSelectNewManager"
          />
        </div>

        <div class="searchBox flex align-center justify-sb">
          <van-icon name="search" color="#B3B3B3" size="24" />

          <input
            type="text"
            v-model="state.queryName"
            class="flex-1"
            placeholder="请输入客户名称或手机号搜索"
            @update:model-value="handleQueryName($event)"
          />
        </div>

        <!-- <van-pull-refresh
          v-if="state.listData.length"
          v-model="state.isRefresh"
          pull-distance="80"
          @refresh="onRefresh"
        >
          <van-list
            v-model:loading="state.listLoading"
            :finished="state.finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              v-for="item in state.listData"
              :key="item?.user?.uuid"
              class="customerItem rel"
              :class="item.isSelected ? 'active' : ''"
              @click="handleSelectCustomer(item)"
            >
              <div class="up flex align-center">
                <img
                  :src="item?.user?.wx_user?.avatar_url || EmptyHeadImg"
                  class="img"
                  alt=""
                />

                <div class="msg">
                  <div class="name">{{ item?.user?.name }}</div>
                  <div class="gOrA">
                    {{ getGender(item?.user?.sex) }}
                    {{ getAge(item?.user?.birthday) }}岁
                  </div>
                </div>
              </div>

              <div class="down">
                <div class="phone">手机号码：{{ item?.user?.phone }}</div>
              </div>

              <van-checkbox
                v-model="item.isSelected"
                checked-color="#DCBB89"
                class="abs selectedImg"
              >
              </van-checkbox>
            </div>
          </van-list>
        </van-pull-refresh>
        <div v-else class="emptyBox flex align-center justify-sc">
          <van-empty
            :image="emptyCustomerImg"
            image-size="150"
            description="没有该客户？去创建新客户"
          />
        </div> -->

        <div class="pageList">
          <PullAndPush_list
            v-if="isDataReady"
            ref="listRef"
            :request="CustomerApi._customerList"
            :otherParams="otherParams"
            @loaded="onLoaded"
          >
            <template #default="{ list }">
              <div
                v-for="item in list"
                :key="item?.user?.uuid"
                class="customerItem rel"
                :class="item.isSelected ? 'active' : ''"
                @click="handleSelectCustomer(item)"
              >
                <div class="up flex align-center">
                  <img
                    :src="item?.user?.wx_user?.avatar_url || EmptyHeadImg"
                    class="img"
                    alt=""
                  />

                  <div class="msg">
                    <div class="name">{{ item?.user?.name }}</div>
                    <div class="gOrA">
                      {{ getGender(item?.user?.sex) }}
                      {{ getAge(item?.user?.birthday) }}岁
                    </div>
                  </div>
                </div>

                <div class="down">
                  <div class="phone">手机号码：{{ item?.user?.phone }}</div>
                </div>

                <van-checkbox
                  v-model="item.isSelected"
                  checked-color="#DCBB89"
                  class="abs selectedImg"
                >
                </van-checkbox>
              </div>
            </template>
          </PullAndPush_list>
        </div>
      </div>
    </div>

    <div class="bottom_button_box">
      <van-checkbox
        v-model="state.selectAllStatus"
        checked-color="#DCBB89"
        @change="handleSelectAll"
      >
        全选客户
      </van-checkbox>

      <div class="flex">
        <van-button
          round
          plain
          class="save-btn noRadius"
          @click="router.go(-1)"
        >
          取消
        </van-button>

        <van-button
          round
          type="primary"
          color="#DCBB89"
          class="save-btn noRadius"
          @click="handleTransform"
        >
          确认转移
        </van-button>
      </div>
    </div>

    <!-- <van-popup v-model:show="showPositionPicker" round position="bottom">
      <van-picker
        :columns="state.myShopList"
        @cancel="showPositionPicker = false"
        @confirm="onPositionConfirm"
      />
    </van-popup> -->
  </div>
</template>

<script lang="ts" setup>
import dayjs from "dayjs";
import {
  ref,
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { showSuccessToast, showFailToast, showConfirmDialog } from "vant";
import CustomerApi from "@/utils/api/customer";
import MyTeamApi from "@/utils/api/myTeam";
import emptyCustomerImg from "@/assets/img/customer/emptyCustomer.png";
import EmptyHeadImg from "@/assets/img/icons/emptyHeadImg.png";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
const { user_uuid } = route.query;
const manageMsgData = reactive({
  currentName: "",
  currentUserId: "",
  nextName: "",
  nextUserId: "",

  currentShopId: undefined,
  currentShopName: undefined,
});
const showPositionPicker = ref(false);
let department_uuid: undefined | null | string = undefined;
let isDataReady = ref(false);
const state = reactive({
  queryName: undefined,

  listData: [] as any[],
  teamListData: [],

  pagination: {
    page: 1,
    lastPage: 1,
    pageSize: 10,
    lastPageSize: 1,
    total: 0,
  },

  isRefresh: false,
  finished: true,
  listLoading: false,

  selectedIds: [] as string[],
  selectAllStatus: false,

  myShopList: [],
});
const currentManager = computed(() =>
  state.teamListData?.find(
    (v) => v?.shop_clerk_uuid == manageMsgData.currentUserId,
  ),
);
const nextManager = computed(() =>
  state.teamListData?.find(
    (v) => v?.shop_clerk_uuid == manageMsgData.nextUserId,
  ),
);
const otherParams = computed(() => ({
  department_uuid,
  query_condition: state.queryName,
  shop_uuid: manageMsgData.currentShopId,
  page: state.pagination.page,
  page_size: state.pagination.pageSize,
}));
const listRef = ref<any>(null);

// --------------------------------------- 方法、事件
const getGender = (type: number | string) =>
  ({
    1: "男",
    2: "女",
    3: "",
  })[type] || "";

function getAge(birthday) {
  return dayjs().diff(dayjs(birthday), "year");
}

onMounted(async () => {
  let departmentData = JSON.parse(localStorage.getItem("departmentdata"));
  department_uuid = departmentData?.department_uuid;

  GroupService.getTeamMember();

  if (sessionStorage.getItem("nextUser")) {
    let nextUser = JSON.parse(sessionStorage.getItem("nextUser"));

    manageMsgData.nextName = nextUser.nextName || "";
    manageMsgData.nextUserId = nextUser.nextUserId || "";

    // sessionStorage.removeItem("nextUser");
  }

  if (user_uuid) {
    GroupService.getCustomerInfo();
  } else {
    let temp = JSON.parse(localStorage.getItem("weComUserInfo"));

    manageMsgData.currentName = temp?.shop_clerk_info?.name || "";
    manageMsgData.currentUserId = temp?.shop_clerk_info?.uuid || "";
  }

  await GroupService.getAllShop();

  let temp = state.myShopList?.find((v) => v.shop_uuid === department_uuid);
  if (!temp) {
    temp = state.myShopList?.[0];
  }

  manageMsgData.currentShopId = temp?.shop?.uuid || "";
  manageMsgData.currentShopName = temp?.shop?.name || "";

  if (!manageMsgData.currentShopId) {
    showFailToast("当前岗位、角色没有门店信息！");
    return;
  }
  isDataReady.value = true;
  //   GroupService.getCustomerMember();
});
onBeforeUnmount(() => {
  sessionStorage.removeItem("nextUser");
});
function onLoaded(payload: { page: number; list: any[] }) {
  state.listData = payload.list;
}

// 选择新负责人
const handleSelectNewManager = () => {
  router.push({
    path: "/selectManager",
    query: { currentUserId: manageMsgData.currentUserId },
  });
};

// // 下拉刷新 -回调
// const onRefresh = async () => {
//   // 重置列表状态
//   state.isRefresh = true;

//   state.listData = [];

//   state.pagination.lastPage = state.pagination.page;
//   state.pagination.lastPageSize = state.pagination.pageSize;

//   state.pagination.page = 1;
//   state.pagination.pageSize =
//     state.pagination.lastPage * state.pagination.lastPageSize;

//   //   await GroupService.getCustomerMember();
// //   listRef.value?.reloadCurrentPage();
//   await nextTick();
//   state.isRefresh = false;
//   state.pagination.pageSize = state.pagination.lastPageSize;
// };
//
// // 上拉加载 -回调 (由 van-list 触发)
// const onLoad = async () => {
//   if (state.listData.length < state.pagination.total) {
//     state.pagination.page += 1;
//     // await GroupService.getCustomerMember();
// //     listRef.value?.reloadCurrentPage();
//   }
// };

// 根据名称搜索
let timer_: any = null;
function handleQueryName(val) {
  state.queryName = val;

  if (timer_) clearTimeout(timer_);
  timer_ = setTimeout(async () => {
    try {
      //   GroupService.getCustomerMember();
      listRef.value?.reloadCurrentPage();
    } catch (error) {
      console.error(error);
    }
  }, 1000); // 500毫秒延迟
}

// // 确认 选择当前岗位
// const onPositionConfirm = async ({ selectedOptions }) => {
//   manageMsgData.currentShopId = selectedOptions[0].value;
//   manageMsgData.currentShopName = selectedOptions[0].text;
//
//   showPositionPicker.value = false;
//
//   // await GroupService.getCustomerMember();
// //   listRef.value?.reloadCurrentPage();
// };
async function onClickTab(tab) {
  let target = state.myShopList.find((v) => v.value == tab.name);
  manageMsgData.currentShopName = target?.text;
  //   GroupService.getCustomerMember();
  await nextTick();
  listRef.value?.reloadCurrentPage();
}

// 选择客户
function handleSelectCustomer(item) {
  let index = state.selectedIds.indexOf(item?.user?.uuid);
  if (index >= 0) {
    state.selectedIds.splice(index, 1);
    item.isSelected = false;
  } else {
    state.selectedIds.push(item?.user?.uuid);
    item.isSelected = true;
  }

  if (state.selectedIds.length >= state.listData.length) {
    state.selectAllStatus = true;
  } else {
    state.selectAllStatus = false;
  }
}
// 全选客户
function handleSelectAll(val) {
  let _selectedId_: string[] = [];
  if (val) {
    state.listData.forEach((item) => {
      item.isSelected = true;
      _selectedId_.push(item.uuid);
    });
  } else {
    state.listData.forEach((item) => {
      item.isSelected = false;
    });
    _selectedId_ = [];
  }
  state.selectedIds = _selectedId_;
}

// 提交 转移
function handleTransform() {
  if (!state.selectedIds.length) {
    showFailToast("请选择要转移的客户！");
    return;
  } else if (!manageMsgData.nextUserId) {
    showFailToast("请选择新负责人！");
    return;
  }

  showConfirmDialog({
    title: "提示",
    message: "是否确认转移？",
    confirmButtonColor: "#DCBB89",
    cancelButtonColor: "#999999",
    width: "90%",
  }).then(async () => {
    CustomerApi._customerTransfer({
      to_shop_clerk_uuid: manageMsgData.nextUserId,
      user_uuids: state.selectedIds,
    })
      .then(async (res) => {
        if (res?.code === 200) {
          showSuccessToast("转移成功！");

          GroupService.getTeamMember();
          //   GroupService.getCustomerMember();
          await nextTick();
          listRef.value?.refresh();
        } else {
          showFailToast("转移失败，请稍后重试！");
        }
      })
      .catch((err) => {
        showFailToast("转移失败，请稍后重试！");
      });
  });
}
// --------------------------------------- 请求
const GroupService = {
  // 当前门店的客户
  getCustomerMember: async () => {
    CustomerApi._customerList({
      page: state.pagination.page,
      page_size: state.pagination.pageSize,
      department_uuid,
      query_condition: state.queryName,
      shop_uuid: manageMsgData.currentShopId,
    }).then((res) => {
      if (res?.code === 200) {
        const newData = res?.data || [];
        const total = res?.total || res?.cnt || 0;

        state.pagination.total = total;

        // 累加数据逻辑
        if (state.pagination.page === 1) {
          // 第一页直接覆盖 (刷新场景)
          state.listData = newData;
        } else {
          // 非第一页追加 (上拉场景)
          state.listData = [...state.listData, ...newData];
        }

        // 【关键判断】是否设置 finished
        if (state.listData.length >= state.pagination.total) {
          state.finished = true;
        } else {
          state.finished = false;
        }
      }
      let timer: any = setTimeout(() => {
        state.listLoading = false;

        clearTimeout(timer);
        timer = null;
      }, 500);
    });
  },

  // 获取当前门店的成员
  getTeamMember: async () => {
    MyTeamApi._myTeamMemberAll2({
      page: 1,
      page_size: 1000,
      department_uuid,
      name: state.name,
    }).then((res) => {
      state.teamListData = res?.data || [];
    });
  },

  // 当前客户的信息
  async getCustomerInfo() {
    let res = await CustomerApi._customerInfo({ user_uuid }).catch((err) => {});
    manageMsgData.currentName =
      res?.data?.user_shop_clerk_info?.shop_clerk_name || "";
    manageMsgData.currentUserId =
      res?.data?.user_shop_clerk_info?.shop_clerk_uuid || "";
  },

  // 当前 门店负责人的所有门店
  async getAllShop() {
    let res = await CustomerApi._customerShop({
      shop_clerk_uuid: manageMsgData.currentUserId,
    }).catch((err) => {});

    state.myShopList = (res?.data || [])?.map((v) => ({
      ...v,
      text: v.shop?.name,
      value: v.shop?.uuid,
    }));
  },
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.mainContent {
  padding: 0;

  .icon {
    width: 28px;
    height: 28px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    &.editIcon {
      width: 24px;
      height: 24px;
      background-image: url("@/assets/img/icons/edit.png");
      vertical-align: middle;
    }
  }

  .van-tabs {
    height: 52px;

    :deep(.van-tabs__wrap) {
      height: 100% !important;

      .van-tab__text {
        height: 22px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .van-tab--active .van-tab__text {
        font-weight: 600;
        font-size: 16px;
        color: #333333;
      }

      .van-tabs__line {
        background: #dcbb89;
      }
    }
  }

  .tips {
    height: 66px;
    line-height: 22px;
    padding: 14px 18px 10px;
    background: rgba(220, 187, 137, 0.08);
    text-align: left;

    span {
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #3c211f;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

  .inner {
    height: calc(100% - 66px - 52px);
    padding: 6px 18px;

    .manageMsg {
      height: 110px;

      .van-cell {
        height: 50%;
      }

      .shopName {
        text-decoration: underline;
        color: #dcbb89;
      }
    }

    .searchBox {
      height: 45px;
      padding: 11px;
      margin-top: 10px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;

      input {
        flex: 1;
        width: calc(100% - 24px - 8px);
        height: 100%;
        border: none;
        outline: none;

        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
      /* WebKit browsers */
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
      /* Mozilla Firefox 4 to 18 */
      input:-moz-placeholder,
      textarea:-moz-placeholder {
        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
      /* Mozilla Firefox 19+ */
      input::-moz-placeholder,
      textarea::-moz-placeholder {
        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
      /* Internet Explorer 10+ */
      input:-ms-input-placeholder,
      textarea:-ms-input-placeholder {
        color: #999;
        font-weight: 400;
        font-size: 14px;
      }
    }

    .emptyBox,
    .pageList,
    .van-pull-refresh {
      height: calc(100% - 110px - 45px - 10px - 10px);
      margin-top: 10px;
      overflow-y: scroll;

      .customerItem {
        padding: 6px;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        border: 1px solid transparent;

        &.active {
          border-color: #dcbb89;
        }

        &:not(:last-child) {
          margin-bottom: 10px;
        }

        .up {
          padding: 11px 10px;
          border-bottom: 1px solid #f2f2f2;

          .img {
            width: 42px;
            height: 42px;
            border-radius: 100%;

            margin-right: 11px;
          }

          .name {
            height: 25px;
            line-height: 25px;
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          .gOrA {
            height: 20px;
            line-height: 20px;
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
        .down {
          padding: 12px 10px 6px;

          font-family:
            PingFang SC,
            PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;

          div {
            height: 20px;
            line-height: 20px;
            &:not(:last-child) {
              margin-bottom: 10px;
            }
          }
        }
        .selectedImg {
          //   width: 16px;
          //   height: 16px;
          top: 16px;
          right: 16px;
        }
      }
    }
  }
}
.bottom_button_box {
  justify-content: space-between;

  :deep(.van-checkbox__label) {
    height: 22px;
    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
